import { Action } from 'redux';
import { RatePlanListAllModel, RatePlanModel } from '../../../api/pricing/pricing.types';
import { Page } from '../../../api/api.types';

export const GET_RATE_PLAN_LIST = 'GET_RATE_PLAN_LIST';
export const GET_RATE_PLAN = 'GET_RATE_PLAN';
export const PUT_RATE_PLAN = 'PUT_RATE_PLAN';
export const POST_RATE_PLAN = 'POST_RATE_PLAN';
export const DELETE_RATE_PLAN = 'DELETE_RATE_PLAN';
export const PATCH_RATE_PLAN_STATUS = 'PATCH_RATE_PLAN_STATUS';
export const STORE_PRODUCT_ID = 'STORE_PRODUCT_ID';
export const STORE_DESK_GROUP_ID = 'STORE_DESK_GROUP_ID';
export const SAVE_PRODUCT_ID = 'SAVE_PRODUCT_ID';
export const SAVE_DESK_GROUP_ID = 'SAVE_DESK_GROUP_ID';
export const STORE_BROKER_RATE_ID = 'STORE_BROKER_RATE_ID';
export const STORE_STARTING_DATE = 'STORE_STARTING_DATE';
export const STORE_DESK_CODE = 'STORE_DESK_CODE';
export const STORE_ACRISS_CODES = 'STORE_ACRISS_CODES';

export interface RatePlanState {
  ratePlans: RatePlanListAllModel[] | [];
  selectedRatePlan: RatePlanModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  productId: number | null;
  deskGroupId: number | null;
  acrissCodes: string[] | null;
  brokerRateCode: string | null;
  deskCode: string | null;
  startingDate: string | null;
}

export interface GetRatePlanListAction extends Action {
  type: typeof GET_RATE_PLAN_LIST;
  payload: {
    page: Page<RatePlanListAllModel>;
  };
}

export interface GetRatePlanAction extends Action {
  type: typeof GET_RATE_PLAN;
  payload: {
    selectedRatePlan: RatePlanModel | null;
  };
}

export interface PutRatePlanAction extends Action {
  type: typeof PUT_RATE_PLAN;
  payload: {
    selectedRatePlan: RatePlanModel;
  };
}

export interface PostRatePlanAction extends Action {
  type: typeof POST_RATE_PLAN;
  payload: {
    success: boolean;
  };
}

export interface DeleteRatePlanAction extends Action {
  type: typeof DELETE_RATE_PLAN;
  payload: {
    success: boolean;
  };
}

export interface StoreProductIdAction extends Action {
  type: typeof STORE_PRODUCT_ID;
  payload: {
    productId: number;
  };
}

export interface StoreDeskGroupIdAction extends Action {
  type: typeof STORE_DESK_GROUP_ID;
  payload: {
    deskGroupId: number;
  };
}

export interface SaveProductIdAction extends Action {
  type: typeof SAVE_PRODUCT_ID;
  payload: {
    productId: number;
  };
}

export interface SaveDeskGroupIdAction extends Action {
  type: typeof SAVE_DESK_GROUP_ID;
  payload: {
    deskGroupId: number;
  };
}

export interface PatchRatePlanStatusAction extends Action {
  type: typeof PATCH_RATE_PLAN_STATUS;
  payload: {
    selectedRatePlan: RatePlanModel;
  };
}

export interface StoreDeskCodeAction extends Action {
  type: typeof STORE_DESK_CODE;
  payload: {
    deskCode: string;
  };
}

export interface StoreBrokerRateCodeAction extends Action {
  type: typeof STORE_BROKER_RATE_ID;
  payload: {
    brokerRateCode: string;
  };
}

export interface StoreStartingDateAction extends Action {
  type: typeof STORE_STARTING_DATE;
  payload: {
    startingDate: string;
  };
}

export interface StoreAcrissCodesAction extends Action {
  type: typeof STORE_ACRISS_CODES;
  payload: {
    acrissCodes: string[];
  };
}

export type RatePlanActionTypes = GetRatePlanListAction |
  GetRatePlanAction |
  PutRatePlanAction |
  PostRatePlanAction |
  DeleteRatePlanAction |
  PatchRatePlanStatusAction |
  StoreProductIdAction |
  StoreDeskGroupIdAction |
  SaveProductIdAction |
  SaveDeskGroupIdAction |
  StoreDeskCodeAction |
  StoreBrokerRateCodeAction |
  StoreStartingDateAction |
  StoreAcrissCodesAction;
